export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  tag: string;
  image: string;
  link: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "slide-1",
    title: "年轻的母亲1",
    subtitle: "一个二十六岁女人成为母亲之后的第一年。没有爽剧，只有真实。",
    tag: "全剧热映",
    image:
      "https://readdy.ai/api/search-image?query=Highly%20stylized%20cinematic%20poster%20scene%20of%20a%20young%20Chinese%20mother%20holding%20her%20baby%20by%20a%20large%20window%20at%20golden%20hour%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20soft%20bokeh%2C%20emotional%20intimate%20atmosphere%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20dark%20moody%20edges%20for%20text%20contrast&width=1600&height=900&seq=nm1-hero-01&orientation=landscape",
    link: "/detail/episode/ep-1",
  },
  {
    id: "slide-2",
    title: "深夜急诊的那一夜",
    subtitle: "第六集被观众称为‘最窒息的一集’，也是全剧转折的起点。",
    tag: "高能剧情",
    image:
      "https://readdy.ai/api/search-image?query=Highly%20stylized%20cinematic%20scene%20of%20a%20dim%20hospital%20corridor%20at%20night%20with%20a%20lone%20figure%20silhouetted%20by%20cold%20blue%20light%20and%20a%20distant%20warm%20lamp%2C%20dramatic%20moody%20atmosphere%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20dark%20edges%20for%20text%20contrast&width=1600&height=900&seq=nm1-hero-02&orientation=landscape",
    link: "/detail/episode/ep-6",
  },
  {
    id: "slide-3",
    title: "从厨房到书桌",
    subtitle: "专题解析：林晓如何一步步找回自己的名字。",
    tag: "深度解析",
    image:
      "https://readdy.ai/api/search-image?query=Highly%20stylized%20cinematic%20scene%20of%20a%20sunlit%20desk%20with%20design%20sketches%20coffee%20and%20a%20laptop%20beside%20a%20softly%20blurred%20window%2C%20warm%20golden%20and%20deep%20navy%20tones%2C%20hopeful%20calm%20atmosphere%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20dark%20moody%20edges%20for%20text%20contrast&width=1600&height=900&seq=nm1-hero-03&orientation=landscape",
    link: "/detail/plot/plot-5",
  },
];

export interface StatItem {
  label: string;
  value: string;
}

export const siteStats: StatItem[] = [
  { label: "全剧集数", value: "12 集" },
  { label: "剧情解析", value: "6 篇" },
  { label: "主要演员", value: "8 位" },
  { label: "累计热度", value: "2300 万+" },
];